import React, { useEffect } from "react";
import { useMediaQuery } from "@chakra-ui/react";
import {
  Box,
  Heading,
  Image,
  LinkBox,
  LinkOverlay,
  Text
} from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper";
import enableSwiperClicksFromNav from "../../helpers/enableSwiperClicksFromNav";
import { handleAppendArrowsToSliders } from "../../helpers/handleAppendArrowsToSliders";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";
import "./sliderLandscape.scss";
import { SliderProps } from "../../types/homePageTypes";


// landscape slider component for year round home page

const SliderLandscape = ({ 
  title, 
  description,
  isWebProgrammeSlider,
  sliderItems
}: SliderProps) => {
  const [isLargerThan1536] = useMediaQuery("(min-width: 1536px)");
  const [isLargerThan1200] = useMediaQuery("(min-width: 1200px)");
  const [isLargerThan992] = useMediaQuery("(min-width: 992px)");
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const [isLargerThan576] = useMediaQuery("(min-width: 567px)");
  const [isSmallerThan576] = useMediaQuery("(max-width: 566px)");
  const { swiperRef } = enableSwiperClicksFromNav();

  let slidesPerView;
  if (isSmallerThan576) {
    slidesPerView = 1.2;
  } else if (isLargerThan576 && !isLargerThan768) {
    slidesPerView = 1.3;
  } else if (isLargerThan768 && !isLargerThan992) {
    slidesPerView = 1.4
  } else if (isLargerThan992 && !isLargerThan1200) {
    slidesPerView = 1.7
  } else if (isLargerThan1200 && !isLargerThan1536) {
    slidesPerView = 2.28
  } else {
    slidesPerView = 2.2
  }

  // create an id for the swiper component
  let swiperId: string = title ? `landscape-${title.replace(/[^a-zA-Z0-9]/g, '')}` : "landscape-0";
  if (swiperId.length > 25) {
    swiperId = swiperId.substring(0, 25);
  }

  // add slider next and previous arrows to target areas
  const nextTarget = `#${ swiperId }.landscapeSlider .swiper-button-next`;
  const prevTarget = `#${ swiperId }.landscapeSlider .swiper-button-prev`;
  handleAppendArrowsToSliders(nextTarget, prevTarget);


  return (
    <Box
      marginBottom={{ base: "50px !important", sm: "80px !important" }}
      marginTop="0 !important"
    >
      {/* section title */}
      <Heading
        as="h2"
        size={{ base: "section-header-mobile", sm: "section-header-tablet", lg: "section-header-desktop" }} 
        marginBottom={{ base: "12px! important", sm: "20px !important" }}
        marginLeft={{ base: "24px !important", sm: "28px !important" }}
      >
        { title }
      </Heading>

      {/* section description */}
      <Text
        size={{ base: "bravo-mobile", sm: "bravo", lg: "bravo-desktop" }}
        color="black !important"
        marginTop="0"
        marginBottom={{ base: "12px !important", sm: "20px !important" }}
        marginLeft={{ base: "24px !important", sm: "28px !important" }}
        p="0 30px 0 0"
      >
        { description }
      </Text>

      {/* slider */}
      {sliderItems.length > 0 &&
        <Swiper
          id={ swiperId }
          className="landscapeSlider"
          onSwiper={( swiperInstance ) => { swiperRef.current = swiperInstance }}
          modules={[ Navigation, A11y ]}
          navigation={ isLargerThan1200 ? true : false }
          slidesPerView={ slidesPerView }
          spaceBetween={ 10 }
        >
          {sliderItems.map(( slide, index ) => {
            return (
              <LinkBox key={ index }>
                <SwiperSlide key={ index }>
                  <LinkOverlay href={ slide.slug } aria-label="link to poster series">
                    <Image
                      w="100%"
                      src={ slide.posterUrl }
                      alt={ slide.posterAlt }
                    />
                  </LinkOverlay>
                </SwiperSlide>
              </LinkBox>
            )
          })}
        </Swiper>
      }
    </Box>
  );
}

export default SliderLandscape;